import {Injectable} from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import {StorageUtils} from '../../../utils';

@Injectable()
export class GuideServices {
    public apiUrl = `${environment.apiUrl}/api/v1`;
    andebug = false;

    constructor(private http: Http) {
        this.andebug = StorageUtils.getItem('an.debug') === 'd' ? true : false;
    };

    getGuideYn() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/guide`;
        if (this.andebug) console.log('>>> getGuideYn(): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getGuideIntegrationType() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/guide/integration/type`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    postGuide(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/guide`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    postGuideIncident(itgrApplInstlNo) {
        const postData = {
            itgrApplInstlNo: itgrApplInstlNo
        };
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/guide/incident`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/guide.services.ts